$.fn.fixLead = function() {
    var items = $(this);
    var model = {
        items: items,
        config: [],
        linesConfig: function(headerLines, leadLines){
            this.config.push([headerLines, leadLines]);
            return this;
        },
        init: function(){
            if(!isMobile()) {
                if(document.fonts){
                    document.fonts.ready.then(this.fix.bind(this));
                } else {
                    document.addEventListener('DOMContentLoaded', this.fix.bind(this));
                }
            }

        },
        findTitle: function(element){
            return element.querySelector('h2');
        },
        findLead: function(element){
            return element.querySelector('.lead');
        },
        getLineHeight: function(element){
            var size = window.getComputedStyle(element).getPropertyValue('line-height');
            size.replace('px', '');
            return parseInt(size);
        },
        getMaxTitleLines: function(){
            var max = 0;
            for(var i=0; i< this.config.length; i++){
                max = Math.max(max, this.config[i][0]);
            }
            return max;
        },
        fix: function(){
            var firstEl = this.items.first()[0];
            var titleLH = this.getLineHeight(this.findTitle(firstEl));
            var leadLLH = this.getLineHeight(this.findLead(firstEl));
            var maxTitleLines = this.getMaxTitleLines();


            $.each(this.items, function(i, el){
                var title = this.findTitle(el);
                var lead  = this.findLead(el);

                var titleLines = Math.round(title.clientHeight / titleLH);
                if(titleLines > maxTitleLines){
                    titleLines = maxTitleLines;
                    this.setLines(title, titleLines, titleLH);
                }

                for(var i=0; i< this.config.length; i++){
                    if(this.config[i][0] == titleLines){
                        this.setLines(lead, this.config[i][1], leadLLH);
                        break;
                    }
                }
            }.bind(this));
        },
        setLines: function(element, lines, lineHeight){
            element.style.webkitLineClamp = lines;
            element.style.maxHeight = (lines * lineHeight) + 'px';
            element.style.overflow = 'hidden';
        }

    }
    return model;
};


$.validator.addMethod("phone", function(phone_number, element) {
    phone_number = phone_number.replace(/\(|\)|\s+|-/g, "");
    return this.optional(element) || phone_number.length == 9 && phone_number.match(/\d{9}/);
    // && phone_number.match(/^(?:(?:(?:00\s?|\+)44\s?|0)7(?:[1345789]\d{2}|624)\s?\d{3}\s?\d{3})$/);

}, "Wpisz poprawny numer telefonu np. 111 222 333, 11-222-33-44");

$.validator.addMethod("price", function(price, element) {
    price = price.replace(/\s+/g, "");
    return this.optional(element) || price.match(/^\d+([\.,]\d{0,2})?$/);
    // && phone_number.match(/^(?:(?:(?:00\s?|\+)44\s?|0)7(?:[1345789]\d{2}|624)\s?\d{3}\s?\d{3})$/);

}, "Wpisz poprawną cenę");



var initSmalladsForm = window.initSmalladsForm =  function(params, mediaFiles){
    console.log('work');

    var dropzone = initDropZone(params, mediaFiles);
    var form = $("#smallads-form");
    var categorySelect = form.find('#f-subcategory_id');
    var requireIfJob = {
        required: function(el){
            return parseInt(categorySelect.val()) == 101;
        }
    }
    form.validate({
        ignore: [],
        // submitHandler: function(form) {
        //     if(mfu.inProgress()){
        //         $('#sendingInfo').text('Wysyłanie zdjęcia...');
        //         mfu.bindStop(function(){
        //             form.submit();
        //         });
        //         return false;
        //     } else {
        //         $('#sendingInfo').text('');
        //     }
        //     if(userID != '0'){
        //         form.submit();
        //         return true;
        //     } else {
        //         params = $(form).serializeArray();
        //         showPopUpRegister("smallads",params);
        //         return false;
        //     }
        // },
        // showErrors: function(errorMap, errorList) {
        //     if(errorMap.productID){
        //         $('.pay-list').addClass('pay-list-error');
        //     }
        //     this.defaultShowErrors();
        // },
        // success: function(label, element) {
        //     //label.addClass("valid").text("Ok!")
        //     if($(element).attr('name') == 'productID'){
        //         $('.pay-list').removeClass('pay-list-error');
        //     }
        // },
        errorPlacement: function(error, element) {
            error.appendTo(element.closest('.control'));
        },
        showErrors: function(errorMap, errorList) {
            if(errorMap.private){
                $('#private-ratio').addClass('error');
            }
            this.defaultShowErrors();
        },
        success: function(label, element) {
            if($(element).attr('name') == 'private'){
                $('#private-ratio').removeClass('error');
            }
        },
        rules: {
            title: "required",
            content: "required",
            subcategory_id: "required",
            private: "required",
            phone: "phone",
            price: "price",
            'job[profession_id]': requireIfJob,
            //'job[working_time_id]': requireIfJob,
            //'job[contract_id]': requireIfJob,


        },
        messages: {
            title:  "Wpisz tytuł ogłoszenia",
            content:  "Wpisz treść ogłoszenia",
            subcategory_id: "Wybierz kategorię",
            private: "Wybierz rodzaj ogłoszenia",
            'job[profession_id]': "Wybierz branżę",
            //'job[working_time_id]': "Wybierz wymiar pracy",
            //'job[contract_id]': "Wybierz rodzaj umowy",
        }
    });


    var jobFields = form.find('#job-fields');
    var priceField = form.find('#price-field');
    categorySelect.change(function(){
        updatePrivate();
        updateJob();
        updatePrice();
    });
    updatePrivate();
    updateJob();
    updatePrice();

    function updatePrivate(){
        var selected = parseInt(categorySelect.val());
        var field = $('#private-field');
        if([101, 124, NaN].includes(selected)){
            field.hide();
            $('.ratio-box .el:last').click();
        } else {
            field.show();
        }
    }
    function updateJob() {
        var selected = parseInt(categorySelect.val());
        if(selected === 101){
            jobFields.show();
        } else {
            jobFields.hide();
        }
    }
    function updatePrice() {
        var selected = parseInt(categorySelect.val());
        if([101].includes(selected)){
            priceField.hide();
            priceField.find('input').val('');
        } else {
            priceField.show();
        }
    }

}


window.initDropZone  = function initDropZone(params, mediaFiles){
    var maxFilesParams = params.maxFiles || 8;
    var sortableParams = params.sortable === undefined ? true : params.sortable;



    var emptyManager = {
        emptyEls: null,
        maxFiles: null,
        init: function(zone){
            this.emptyEls = $('.upload-list-template li:visible');
            this.maxFiles = zone.options.maxFiles;
            zone.on("addedfile", function() {
                emptyManager.changeEmpty(zone.files.length);
            });
            zone.on("removedfile", function(){
                emptyManager.changeEmpty(zone.files.length);
            });
        },
        changeEmpty(filesCount){
            $.each(emptyManager.emptyEls, function(i, el){
                if(i < filesCount) {
                    $(el).hide();
                } else {
                    $(el).show();
                }
            });
            if(maxFilesParams > filesCount && maxFilesParams > emptyManager.emptyEls.length) {
                emptyManager.emptyEls.last().show();
            }
            console.log(emptyManager.emptyEls.last());
        }

    }

    var idManager = {
        list: null,
        input: null,
        init: function(zone){
            this.list = $('#drop-zone-con .previews');
            this.input = $('#media-upload');
            zone.on("complete", function(file){
                var el = file.previewElement;
                if(file.xhr) {
                    var res = JSON.parse(file.xhr.responseText);
                } else {
                    res = file;
                }
                el.dataset.id = res.id;
                el.dataset.path = res.path;
                idManager.update();
            });
            zone.on("removedfile", function(){
                idManager.update();
            });
            if(sortableParams){
                this.initSortable();
            }
        },

        initSortable: function(){
            var el = document.querySelector('#drop-zone-con .previews');
            el.classList.add("is-sortable");
            var sortable = Sortable.create(el, {
                animation: 150,
                ghostClass: "ghost",
                forceFallback: true,
                fallbackTolerance: 1,
                onEnd: function (e) {
                    idManager.update();
                }
            });
        },

        update(){
            var els = this.list.find('.dz-preview');
            var ids = [];
            $.each(els, function(){
                var id = $(this).data('id');
                if(id){
                    ids.push(id);
                }
            });
            this.input.val(ids.join(','));
        }

    }

    var dropzone = new Dropzone(document.body, {
        url: "/media/store",
        maxFiles: maxFilesParams,
        params: params,
        acceptedFiles: 'image/jpeg',
        previewsContainer: '#drop-zone-con .previews',
        clickable: '.upload-list-template li',
        thumbnailWidth: 240,
        thumbnailHeight: 240,

        init: function(){
            this.on("error", function(file, e) {
                if (file.xhr){
                    alert('Błąd wysyłania pliku');
                }
                this.removeFile(file);
            });
            this.on("removedfile", function(){});


            emptyManager.init(this);
            idManager.init(this);
            this.options.initRemoveLink.bind(this)();

        },

        initRemoveLink(){
            this.on("addedfile", function(file) {
                var el = file.previewElement;
                var _this = this;
                var removeLink = $('<a href="#" class="dz-remove" title="Usuń"><i class="mdi mdi-delete"></i></a>');
                //if(file.id == undefined){  // DUNO TODO
                    removeLink.click(function(){
                        _this.removeFile(file);
                        return false;
                    });
                //}
                el.appendChild(removeLink[0]);

            });
        },
    });


    $(mediaFiles).each(function(){
        dropzone.files.push(this);
        dropzone.emit("addedfile", this);
        dropzone.emit("thumbnail", this, this.thumbnail);
        dropzone.emit("complete", this);
    });




    return dropzone;
};



var initSmallads = window.initSmallads = function() {
    var phoneFlag = false;
    var phones = $('.phone-box');
    phones.click(function(){
        if(!phoneFlag){
            phones.find('.show-phone').remove();
            var number = $(this).find('span').data('phone');
            phones.find('span').text(number);
            phoneFlag = true;
            phones.removeClass('click');
            $.post('/smallads/' + $('#smallads_id').val() +'/phone');
        }
        return false;
    });



    $("#replay-form").validate({
        submitHandler: function(form) {
            form = $(form);
            var params = form.serializeArray();
            form.lockForm();

            $.post("/smallads/" + $('#smallads_id').val() + "/replay", params, function(data){
                form.html(data);
            }).fail(function() {
                form.html('<p class="error">Wystąpił błąd podczas wysyłania wiadomości </p>');
            });
            return false;
        },
        rules: {
            content: "required",
            email: { required: true, email: true  }
        },
        messages: {
            content:  "Wpisz treść odpowiedzi",
            email: { required: "Wpisz adres email", email: "Niepoprawny adres email" }
        }
    });

}


var classifiedsStats = window.classifiedsStats = {

    init:function(){
        window.addEventListener("load", function(){
            classifiedsStats.send();
        });
    },

    send: function(doc){
        doc = doc || document;
        let cf = doc.querySelectorAll('.classifieds-stats');
        let data = [];
        cf.forEach(function(el){
            data.push({ id: el.dataset.id, type: el.dataset.type});
        })
        console.log(data);


        fetch('/smallads/stats', {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({smallads: data}) // body data type must match "Content-Type" header
        }).then((response) => response.text())
        .then(function(data){
            console.log("STATS", data);
        });

    }

}



// WEBPACK FOOTER //
// ./Resources/assets/js/smallads.js